import { render, staticRenderFns } from "./ServiceOfferingCurrentYear.vue?vue&type=template&id=5f54ec5d&scoped=true"
import script from "./ServiceOfferingCurrentYear.vue?vue&type=script&lang=js"
export * from "./ServiceOfferingCurrentYear.vue?vue&type=script&lang=js"
import style0 from "./ServiceOfferingCurrentYear.vue?vue&type=style&index=0&id=5f54ec5d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f54ec5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f54ec5d')) {
      api.createRecord('5f54ec5d', component.options)
    } else {
      api.reload('5f54ec5d', component.options)
    }
    module.hot.accept("./ServiceOfferingCurrentYear.vue?vue&type=template&id=5f54ec5d&scoped=true", function () {
      api.rerender('5f54ec5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/ServiceOfferingCurrentYear.vue"
export default component.exports